(ns nosco.interop.downshift
  (:require [clojure.string :refer [lower-case replace]]
            ["downshift" :as downshift]
            [goog.object]))

(defn- remove-nils
  "Removes all entries from a map where value is `nil?`"
  [obj]
  (into {} (remove (comp nil? second) obj)))

(defn- kebab-case-keyword [k]
  (keyword (replace (name k) #"[A-Z]" #(str "-" (lower-case %1)))))

(defn- kebab-case-map [m]
  (into {} (map (fn [[k v]] [(kebab-case-keyword k) v]) m)))

(defn use-select
  "Define an interop abstraction for Downshift's useSelect hook.

   - All data going in and coming out of this hook and other
     getter functions (like getToggleButtonProps) is Clojure data.
   - All options, and returned functions have kebab-case naming
     instead of the library's default camelCase.
   - All other expectations are fully inline with Downshift's official
     documentation"
  [{:keys [;; basic props
           items
           item-to-string
           on-selected-item-change
           state-reducer

           ;; advanced props
           initial-selected-item
           initial-is-open
           initial-highlighted-index
           default-selected-item
           get-a11y-status-message
           get-a11y-selection-message
           on-highlighted-index-change
           on-is-open-change
           on-state-change
           highlighted-index
           is-open
           selected-item
           id
           label-id
           menu-id
           toggle-button-id
           get-item-id
           environment
           circular-navigation]}]
  (let [use-select-props
        (-> {;; basic props
             :itemToString #(item-to-string (js->clj % :keywordize-keys true))
             :onSelectedItemChange (fn [x]
                                     (on-selected-item-change
                                      (kebab-case-map (js->clj x :keywordize-keys true))))
             :stateReducer state-reducer

                       ;; advanced props
             :initialSelectedItem initial-selected-item
             :initialIsOpen initial-is-open
             :initialHighlightedIndex initial-highlighted-index
             :defaultSelectedItem default-selected-item
             :getA11yStatusMessage get-a11y-status-message
             :getA11ySelectionMessage get-a11y-selection-message
             :onHighlightedIndexChange on-highlighted-index-change
             :onIsOpenChange on-is-open-change
             :onStateChange on-state-change
             :highlightedIndex highlighted-index
             :isOpen is-open
             :selectedItem selected-item
             :id id
             :labelId label-id
             :menuId menu-id
             :toggleButtonId toggle-button-id
             :getItemId get-item-id
             :environment environment
             :circularNavigation circular-navigation}

            remove-nils
            clj->js)
        ;; avoid passing items through clj->js to maintain things like keywords
        _ (goog.object/set use-select-props "items" (into-array items))
        {:keys [;; getters
                getToggleButtonProps
                getItemProps
                getMenuProps
                getLabelProps

                ;; actions
                closeMenu
                openMenu
                selectItem
                setHighlightedIndex
                toggleMenu
                reset

                ;; state
                isOpen
                selectedItem
                highlightedIndex
                keysSoFar]}
        (js->clj (downshift/useSelect use-select-props)
                 :keywordize-keys true)]

    {;; getters
     :get-toggle-button-props #(js->clj (getToggleButtonProps) :keywordize-keys true)
     :get-item-props #(js->clj (getItemProps (clj->js %)) :keywordize-keys true)
     :get-menu-props #(js->clj (getMenuProps) :keywordize-keys true)
     :get-label-props #(js->clj (getLabelProps) :keywordize-keys true)

     ;; actions
     :close-menu closeMenu
     :open-menu openMenu
     :select-item selectItem
     :set-highlighted-index setHighlightedIndex
     :toggle-menu toggleMenu
     :reset reset

     ;; state
     :open? isOpen
     :selected-item selectedItem
     :highlighted-index highlightedIndex
     :keys-so-far keysSoFar}))
